import React from "react"
import { Play } from "react-feather"
import { useSelector } from "react-redux"
import { Button, Card } from "reactstrap"
import { EndDialogContent } from "../"
import { toggleTime } from "../../api/socket/functions"
import styles from "./UnPause.module.scss"

function UnPause() {
	const { isPaused, team, notStarted } = useSelector((state) => state.time)
	const spectate = localStorage.getItem("spectate")

	if (!isPaused) return <></>

	const unPause = () => toggleTime({ isPaused: false })
	const getText = () => {
		if (team)
			return (
				<>
					<h1>{team}</h1>
					<p>Ekipa {team} je zatražila time-out</p>
				</>
			)

		return <h1>Utakmica je pauzirana</h1>
	}

	return (
		<div className={styles.whiteout}>
			<Card className={styles.wrapper}>
				{notStarted ? (
					<EndDialogContent unPause={unPause} />
				) : (
					<>
						{getText()}
						{!spectate ? (
							<div>
								<Button.Ripple
									className="btn-icon rounded-circle"
									color="flat-primary"
									size="lg"
									onClick={unPause}
								>
									<Play />
								</Button.Ripple>
							</div>
						) : (
							<div style={{ marginTop: 16 }}></div>
						)}
					</>
				)}
			</Card>
		</div>
	)
}

export default UnPause
